import styled from 'styled-components'

export const StyledTable = styled.table`
  border-spacing: 0;
  background-color: ${props => props.theme.colors.white.base};
  width: calc((var(--table-size) * 1px) + (var(--header-last-column-size) * 1px));
  display: grid;
`

export const TableWrapper = styled.div`
  background-color: ${props => props.theme.colors.white.base};
`

export const TableRow = styled.tr<{ $rowHeight: number }>`
  display: flex;

  min-height: ${props => props.$rowHeight}px;
  height: ${props => props.$rowHeight}px;
  & [data-cell-disabled='true'] {
    opacity: 0.5;
  }
`

export const TableBody = styled.tbody`
  &: hover {
    background-color: ${props => props.theme.colors.primary.lightest};
  }
`
